import axios from "axios";

export const API_BASE_URL = "https://uktomars.co.uk/api";

export const getToken = () =>
  localStorage.getItem("sessionToken") || localStorage.getItem("token");

export const isAdminRole = (role) =>
  String(role ?? "").toLowerCase() === "admin";

export const getStoredUserRole = () => localStorage.getItem("userRole");

export const clearAuthStorage = () => {
  localStorage.removeItem("sessionToken");
  localStorage.removeItem("token");
  localStorage.removeItem("userRole");
};

export const extractUserFromAuthResponse = (data) =>
  data?.user ?? data?.data?.user ?? data?.data ?? null;

export const getAuthHeaders = () => {
  const token = getToken();
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export const getUploadAuthHeaders = () => {
  const token = getToken();
  const headers = { Accept: "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export const logout = async () => {
  try {
    await axios.post(`${API_BASE_URL}/auth/logout`, {}, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Logout API error:", error);
  }
};

export const login = async (email, password) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/auth/login`, {
      email,
      password,
    });
    return res.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.errors?.email?.[0] ||
      "Login failed. Please try again.";
    throw new Error(message);
  }
};

export const getProfile = async () => {
  const res = await fetch(`${API_BASE_URL}/me`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    throw new Error(`HTTP error! Status: ${res.status}`);
  }
  const responseData = await res.json();
  return responseData?.data ?? responseData;
};

export const updateProfile = async (payload) => {
  const res = await fetch(`${API_BASE_URL}/me`, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData?.message || `HTTP error! Status: ${res.status}`,
    );
  }
  const responseData = await res.json();
  return responseData?.data ?? responseData;
};

export const GPS = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/gps-device`);
    return res.data;
  } catch (error) {
    console.error("Error fetching analytics data :", error);
    throw error;
  }
};
export const Router = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/posts`);
    return res.data;
  } catch (error) {
    console.error("Error fetching pinned products:", error);
    throw error;
  }
};
